/** @format */

export const ALWAYS_HIDDEN_FIELDS = new Set(['_id'])
export const ALWAYS_VISIBLE_FIELDS = new Set(['_date', '_selection'])
export const EMPTY_KEY = '_blank'

export const RESERVED_FIELDS = new Set([
  '_date',
  '_id',
  '_selection',
  '_status',
])

export const MS_PER_DAY = 1000 * 60 * 60 * 24
export const THIRTY_DAYS_MS = 30 * MS_PER_DAY
